<template>
  <div class="card vue-avatar-cropper-demo text-center">
    <div class="card-body">
      <img :src="item.icon" class="card-img avatar" />
      <div class="card-img-overlay">
        <button class="btn btn-primary btn-sm" id="pick-icon">Select a new image</button>
      </div>
    </div>
    <div class="card-footer text-muted" v-html="message"></div>
    <avatar-cropper
      @uploading="handleUploading"
      @uploaded="handleUploaded"
      @completed="handleCompleted"
      :upload-headers="header"
      @error="handlerError"
      :labels="{ submit: 'Submit', cancel: 'Abort'}"
      trigger="#pick-icon"
      :upload-url="url"
      :cropper-options="{aspectRatio: 0.884}"
    />
  </div>
</template>

<script>
import AvatarCropper from 'vue-avatar-cropper';

export default {
  components: { AvatarCropper },
  data() {
    return {
      header: {Authorization: this.$http.defaults.headers.common['Authorization']},
      message: 'Upload new logo',
      url: process.env.VUE_APP_BASE_URL + '/upload',
      item: {
        id: 1,
        icon:
          'https://www.nuiteq.com/hs-fs/hubfs/nuiteq.com/Images/Nuiteq2019/snowflakeHexagon.png?width=138&name=snowflakeHexagon.png'
      }
    };
  },
  methods: {
    handleUploading(form, xhr) {
      this.message = 'uploading...';
    },
    handleUploaded(response) {
      if (response) {
        this.item.icon = response.url;
        this.message = 'Product image updated.';
      }
    },
    handleCompleted(response, form, xhr) {
      this.message = 'Upload completed.';
    },
    handlerError(message, type, xhr) {
      this.message = 'Oops! Something went wrong...';
    }
  }
};
</script>

<style>
.vue-avatar-cropper-demo {
  max-width: 18em;
  margin: 0 auto;
}
.avatar {
  width: 160px;
  border-radius: 6px;
  display: block;
  margin: 20px auto;
}
.card-img-overlay {
  display: none;
  transition: all 0.5s;
}
.card-img-overlay button {
  margin-top: 20vh;
}
.card:hover .card-img-overlay {
  display: block;
}
</style>
